/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CasesToForwardAssignRequest } from '../../models/cases-to-forward-assign-request';
import { Tour } from '../../models/tour';

export interface AssignRsaCase$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: CasesToForwardAssignRequest
}

export function assignRsaCase(http: HttpClient, rootUrl: string, params: AssignRsaCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, assignRsaCase.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

assignRsaCase.PATH = '/api/v1/rsa/tours/{id}/assign_case';
